// mui
import { Container, Typography, Box } from "@mui/material";
// components
import SavingsCard from "./SavingsCard";
// stylesheets
import "./Calculator.css";
import backgroundImage from "../../../assets/images/background.png";

export default function Calculator() {
  return (
    <Box
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
      }}
    >
      <Container>
        <Box sx={{ my: 12 }} style={{ paddingBottom: "10%" }}>
          <Typography
            className="header"
            variant="h2"
            sx={{
              my: 4,
              fontWeight: 500,
              color: "white"              
            }}
          >
            Fuel & Emission Reduction
          </Typography>
          <Box className="paragraph-box" sx={{ my: 5, width: "70%" }}>
            <Typography
              className="paragraph"
              variant="p"
              sx={{ fontFamily: "Rubik", color: "white", fontSize: 18 }}
            >
              We’ve assessed the potential savings of various vessels to give
              you an idea of how much these specific ships could save with
              Anemoi Rotor Sails. Please email sales@anemoimarine.com if your
              vessel type isn’t listed or you’d like more information.
            </Typography>
          </Box>
          <SavingsCard />
        </Box>
      </Container>
    </Box>
  );
}
